@if (artikelMenge(); as artikelMenge) {
  <div class="flex flex-col">
    <span class="text-sm color-light">{{ artikelMenge.artikel.nummer }}</span>
    <span class="text-lg font-semibold">{{ artikelMenge.artikel.artbez1 }}</span>
    <span class="text-sm color-light">{{ artikelMenge.artikel.artbez2 }}</span>
    <span class="text-sm color-light">{{ artikelMenge.artikel.artbez3 }}</span>
    <span class="text-sm color-light">{{ artikelMenge.artikel.artbez4 }}</span>
    <span class="text-sm color-light">{{ artikelMenge.artikel.artbez5 }}</span>
    @if ($safeNavigationMigration(artikelMenge?.artikel?.beschreibung) | isDefinedNotEmpty) {
      <span
        class="text-sm color-light"
        [innerText]="$safeNavigationMigration(artikelMenge.artikel?.beschreibung)"
      ></span>
    }
  </div>
  <div class="flex flex-row flex-nowrap color-light items-center text-xl">
    @if (showInvMenge() && artikelMenge?.menge_inv) {
      <span>{{ artikelMenge.menge_inv | number: '1.0-9' }}</span>
      <span class="ml-1">{{ artikelMenge.einheit.arteh }}</span>
    } @else if (!hideQuantity()) {
      @if (
        isDefinedNotEmpty($safeNavigationMigration(artikelMenge?.arteheingabePflicht)) &&
        artikelMenge?.arteheingabePflicht === true
      ) {
        <div class="flex flex-col items-end">
          <div>
            <span>{{ artikelMenge.menge_lg | number: '1.0-9' }}</span>
            <span class="ml-1">{{ artikelMenge.einheit_lg.arteh }}</span>
          </div>

          <div class="text-xs text-light italic opacity-90">
            =&nbsp;<span class="text-right">{{
              artikelMenge.menge | number: '1.0-9'
            }}</span>
            <span class="ml-1 text-right">{{ artikelMenge.einheit.arteh }}</span>
          </div>
        </div>
      } @else {
        <span>{{ artikelMenge.menge | number: '1.0-9' }}</span>
        <span class="ml-1">{{ artikelMenge.einheit.arteh }}</span>
      }
    }
  </div>
}
